'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActiveHotel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HotelOptionHeader = require('./HotelOptionHeader.jsx');

var _HotelOptionHeader2 = _interopRequireDefault(_HotelOptionHeader);

var _HotelName = require('./HotelName.jsx');

var _HotelName2 = _interopRequireDefault(_HotelName);

var _HotelInfoPanel = require('./HotelInfoPanel.jsx');

var _HotelInfoPanel2 = _interopRequireDefault(_HotelInfoPanel);

var _HotelTypeDescriptionPanel = require('./HotelTypeDescriptionPanel.jsx');

var _HotelTypeDescriptionPanel2 = _interopRequireDefault(_HotelTypeDescriptionPanel);

var _Disclaimer = require('../../../../common/Disclaimer');

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

var _HotelTotalFooter = require('./HotelTotalFooter.jsx');

var _HotelTotalFooter2 = _interopRequireDefault(_HotelTotalFooter);

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ActiveHotel(_ref) {
  var components = _ref.components,
      option = _ref.option,
      optionNumber = _ref.optionNumber,
      t = _ref.t;

  var styleHotelOptionContainer = (0, _emailStyleTools.containerStyles)(components, 'HotelOptionContainer');
  var styleHotelOptionLabel = (0, _emailStyleTools.textStyles)(components, 'HotelOptionLabel');
  var styleHotelCommentContainer = (0, _emailStyleTools.containerStyles)(components, 'HotelCommentContainer');
  var styleHotelComment = (0, _emailStyleTools.textStyles)(components, 'HotelComment');

  var optionPrice = (0, _basketHelpers.getDisclaimerText)(option.optionPrice);

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'ActiveHotel' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_HotelOptionHeader2.default, {
            containerStyle: styleHotelOptionContainer,
            textStyle: styleHotelOptionLabel,
            text: t('common.option') + ' ' + optionNumber,
            URL: (0, _basketHelpers.getHotelImagesURL)(option),
            isActive: (0, _basketHelpers.getHotelIsActive)(option),
            t: t
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_HotelName2.default, {
            components: components,
            name: (0, _basketHelpers.getHotelName)(option)
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_HotelInfoPanel2.default, {
            components: components,
            option: option,
            t: t
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_HotelTypeDescriptionPanel2.default, {
            components: components,
            description: (0, _basketHelpers.getHotelDescription)(option),
            meal: (0, _basketHelpers.getHotelMeal)(option, t),
            roomView: (0, _basketHelpers.getHotelRoomView)(option, t),
            bedType: (0, _basketHelpers.getHotelBedType)(option, t),
            refundableText: (0, _basketHelpers.getRefundableText)(option),
            t: t
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_HotelTotalFooter2.default, {
            components: components,
            option: option,
            total: (0, _basketHelpers.getHotelTotal)(option),
            totalCurrency: (0, _basketHelpers.getHotelTotalCurrency)(option),
            footerMessage: (0, _basketHelpers.getHotelPriceFooterMessage)(option),
            t: t
          })
        )
      ),
      optionPrice && _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Disclaimer2.default, { padTen: _emailStyleTools.padTen,
            containerStyle: styleHotelCommentContainer,
            textStyle: styleHotelComment,
            text: optionPrice
          })
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/ActiveHotel.jsx
// module id = 1520
// module chunks = 0